import React from "react";
import { styles } from "./PostTypeMediaButton.styles";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";
import { classNames } from "../../../utils/common/styling";

const PostTypeMediaButton = ({
  onClick,
  Icon,
  className,
}: {
  onClick?: React.DOMAttributes<HTMLDivElement>["onClick"];
  Icon: OverridableComponent<SvgIconTypeMap> & { muiName: string };
  className?: string;
}) => (
  <div
    className={classNames(styles.postTypeMediaButton, className)}
    onClick={onClick}
  >
    <Icon htmlColor="white" fontSize="small" />
  </div>
);

export default PostTypeMediaButton;
